<div *ngIf="languages.length > 1" class="topbar-item px-5">
    <ul class="horizontal pipe">
        <li *ngFor="let language of languages">
            <a href="javascript:;" (click)="changeLanguage(language.name)">
                <span [class]="textCssClass" [class.active]="currentLanguage.name == language.name">{{language.name | languageAbbr}}</span>
            </a>
        </li>
    </ul>
</div>
